import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import showAlert from "utils/showAlert";

export default function CreateOrg(props) {
  let createOrgIcon = require("images/lite/icons/graph-scatter.svg");
  createOrgIcon = <img className="onboarding-icon" src={`/datapulse${createOrgIcon}`} />;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [newOrgName, setNewOrgName] = useState("");
  const [newOrgType, setNewOrgType] = useState("agency");

  // Logo
  const defaultLogo = require("images/lite/icons/logo-placeholder.png");
  const [orgLogoUrl, setOrgLogoUrl] = useState(props.org_logo_url ? props.org_logo_url : `/datapulse${defaultLogo}`);
  const [orgLogoFile, setOrgLogoFile] = useState(props.org_logo ? props.org_logo : "");
  const inputRef = useRef();
  const orgLogo = <img src={orgLogoUrl} alt="Organization Logo" />;

  const showModal = () => setIsModalVisible(true);
  const hideModal = () => setIsModalVisible(false);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 10000000) {
      alert("Image must be less than 10MB. Consider using another image or compressing this one.");
    } else if (file) {
      const fileUrl = URL.createObjectURL(file);
      setOrgLogoUrl(fileUrl);
      setOrgLogoFile(file);
    }
  };

  const createOrg = async (event) => {
    event.preventDefault();
    let hasError = false;

    if (!newOrgName) {
      hasError = true;
      document.getElementById("new-org-name").classList.add("lite-invalid-input");
    }

    if (hasError) {
      return;
    }

    setIsCreating(true);

    // Create a new FormData object to handle the multipart data
    const formData = new FormData();
    formData.append("organization_name", newOrgName);
    formData.append("organization_type", newOrgType);

    if (orgLogoFile) {
      formData.append("organization_logo", orgLogoFile);
    }

    try {
      const response = await fetch("/datapulse/organization/create", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: formData,
      });

      console.log(response);

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          window.location.href = "/datapulse/account-management?create_first_account=true"; // Redirect to client management page and prompt user to create a new client
        } else {
          if (data.error) {
            showAlert(data.error, "danger");
          } else {
            showAlert("Failed to create organization. Please try again later.", "danger");
          }
        }

      } else {
        showAlert("Failed to create organization. Please try again later.", "danger");
      }
    } catch (error) {
      console.log(error)
      showAlert("An error occurred while creating the organization. Please try again later.", "danger");
    } finally {
      setIsCreating(false);
      hideModal();
    }
  };

  return (
    <>
      <div className="lite-onboarding-btn create-org" onClick={showModal}>
        {createOrgIcon}
        <p>
          Create<br></br>organization
        </p>
      </div>

      <Modal show={isModalVisible} onHide={hideModal} className="create-org-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Create your organization</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4 new-org-info">
            <div className="new-org-info-card">
              <div className="lite-form-group mb-4">
                <label className="input-label mb-2" htmlFor="new-org-name">
                  Organization Display Name
                </label>
                <input
                  type="text"
                  id="new-org-name"
                  className="lite-input"
                  placeholder="Enter organization name"
                  value={newOrgName}
                  onChange={(e) => setNewOrgName(e.target.value)}
                />
              </div>
              <div className="lite-form-group">
                <label className="input-label mb-2" htmlFor="new-org-type">
                  Organization Type
                </label>
                <div className="select-wrapper">
                  <select className="lite-select" id="new-org-type" value={newOrgType} onChange={(e) => setNewOrgType(e.target.value)}>
                    <option value="agency">Agency</option>
                    <option value="business">Business</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="new-org-info-card text-align-center">
              <div className="lite-form-group mb-4">
                <div className="lite-logo">
                  <label className="input-label mb-4" htmlFor="new-org-logo">
                    Logo (Optional)
                  </label>
                  <div className="logo-display mb-4">{orgLogo}</div>
                  <div>
                    <input style={{ display: "none" }} name="client_logo" type="file" ref={inputRef} onChange={handleLogoChange} />
                    <button
                      className="button b-type-secondary b-size-normal icon-upload"
                      onClick={(e) => {
                        e.preventDefault();
                        inputRef.current.click();
                      }}>
                      <img src={`/datapulse${require("images/lite/icons/upload.png")}`} alt="Upload Icon" />
                      Upload<span className="desktop-only"> logo</span>
                    </button>
                  </div>
                  <div className="logo-note mt-2">
                    <p>Use a square (1:1) image for best results.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="lite-modal-footer">
          <button type="button" className="button b-type-secondary b-size-normal" onClick={hideModal} disabled={isCreating}>
            Cancel
          </button>
          <button
            type="submit"
            className="button b-type-primary b-size-normal b-color-green"
            id="save-changes-button"
            onClick={createOrg}
            disabled={isCreating}>
            {isCreating ? (
              "Creating..."
            ) : (
              <>
                ✔ Save<span className="desktop-only"> and continue</span>
              </>
            )}
          </button>
        </div>
      </Modal>
    </>
  );
}
